import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Matías G.',
  city: 'Buenos Aires',
  text: 'Desde que aplico el capítulo de potencia, mi salto cambió por completo. Ahora defino por arriba de la defensa sin que me toquen. Tremendo material.',
  rating: 5
}, {
  name: 'Camila R.',
  city: 'Córdoba',
  text: 'Siempre llegaba a los últimos 10 minutos sin piernas. La parte de resistencia específica me salvó. Ahora rindo igual en el minuto 1 que en el 59.',
  rating: 5
}, {
  name: 'Lucas P.',
  city: 'Rosario',
  text: 'Jugando de pivote necesitaba ganar fuerza para el contacto. El plan de 8 semanas me dio una base durísima. Nadie me mueve de la línea ahora.',
  rating: 5
}, {
  name: 'Sofía M.',
  city: 'Mendoza',
  text: 'Muy claro y al pie. Dejé de hacer rutinas genéricas de gimnasio y empecé a entrenar como jugadora de handball. Mis cambios de dirección son mucho más rápidos.',
  rating: 5
}, {
  name: 'Federico A.',
  city: 'La Plata',
  text: 'El hombro me mataba después de cada partido. Con los ejercicios preventivos y de potencia de lanzamiento, no solo no me duele más, sino que lanzo mucho más fuerte.',
  rating: 5
}];
export function Testimonials() {
  return <section className="py-12 px-4 bg-brand-base" data-id="element-110">
      <div className="max-w-3xl mx-auto" data-id="element-111">
        <h2 className="text-3xl md:text-4xl font-oswald font-bold text-center mb-10 text-white uppercase tracking-wide" data-id="element-112">
          Jugadores que ya <span className="text-accent-base" data-id="element-113">mejoraron</span>{' '}
          su nivel
        </h2>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-114">
          {testimonials.map((t, i) => <div key={i} className={`bg-brand-light p-6 rounded-xl border border-white/5 shadow-lg ${i === 4 ? 'md:col-span-2 md:max-w-md md:mx-auto' : ''}`} data-id="element-115">
              <div className="flex gap-1 mb-3 text-accent-base" data-id="element-116">
                {[...Array(t.rating)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-117" />)}
              </div>
              <p className="text-gray-200 italic mb-4 text-sm md:text-base leading-relaxed" data-id="element-118">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-119">
                <div className="w-10 h-10 rounded-full bg-brand-dark flex items-center justify-center text-accent-base font-oswald font-bold" data-id="element-120">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-121">
                  <p className="text-white font-bold text-sm" data-id="element-122">{t.name}</p>
                  <p className="text-gray-400 text-xs" data-id="element-123">{t.city}, Argentina</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}